import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { string, object } from 'yup';
import ExportpriceForm from "../Components/Exportprice";
import { pricelistcheck,pricelistadd, setError } from "../Actions/Pricelist.action";
import { translate } from '../Services/translation';
import constants from '../constants';

class ExportpriceContainer extends Component {
    constructor(props) {
      super(props);
      this.bulkinsertref = React.createRef();
      this.state = {
        error: "",
        result: {},
        isclear:false,
      };
      this.props.pricelistcheck();
    }
  
    deleteexisting() {
      this.setState({
        error: "",
        result: {},
       isclear:true,
      });
      
    }
  
    exportPricelist() {
      console.log(this.props.result);
      this.setState({
        error: "",
        result: {},
       isclear:true,
      });
       var res= this.props.pricelistadd(this.bulkinsertref.current);
      
    }
    componentWillReceiveProps(nextProps) {
      if (nextProps.result.isSuccess) {
        this.setState({
          error: "",
         isclear:false,
        });
      }
    }
  
    render() {
      return (
        <Fragment>
        {
          <span ref={this.bulkinsertref}>
          <ExportpriceForm
          btnref={this.buttonRef}
          errors={this.state.error}
          result={this.props.result}
          isclear={this.state.isclear}
          onDismiss={() => this.deleteexisting()}
          onSubmit={() => this.exportPricelist()}
          />
          </span>
    }
      </Fragment>
      );
    }
  }
  
  const mapStateToProps = (state) => {
    return {
      errors: state.pricelist.errors,
      result: state.pricelist.result,
    };
  };
  
  
  
  const mapDispatchToProps = (dispatch) => {
    return {
      pricelistadd: (buttonDomNode) => {
        const nodeIdToShowNotification = buttonDomNode.id = Date.now();
        dispatch(
          pricelistadd({
            nodeIdToShowNotification,
            notificationMessage: translate('mypage.pricelistexport.successmessage'),
            hash: Date.now(),
          })
        );
      },
      pricelistcheck: () => dispatch(pricelistcheck()),
    };
  };
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(ExportpriceContainer);
  